import React from 'react';
import ajax from '../../ajax';
import functions from '../../functions';
import DashCard from '../Common/DashCard';


class SaleGrossProfitCard extends React.Component {
  

  state={
    userId:functions.sessionGuard(),
    accessInfo:false,
    daily:'...',
    monthly:'...'
   
  }


    async componentDidMount()
    {
      await this.getDailySales();
      await this.getMonthlySales();
      this.timerActual = setTimeout(this.func1=async()=> {
        await this.getDailySales();
        this.timerActual = setTimeout(this.func1, 2000); // (*)
      }, 2000);

      this.timerCumm = setTimeout(this.func2=async()=> {
        await this.getMonthlySales();
        this.timerCumm = setTimeout(this.func2, 2000); // (*)
      }, 2000);
    }

    componentWillUnmount()
    {
      clearTimeout(this.timerActual);
      clearTimeout(this.timerCumm);
    }

    getDailySales=async()=>{
      const server_response=await ajax.totalDailyGrossProfit();
      if(server_response.status==="OK")
      {
        this.setState({
          daily:server_response.details.amount_c
        })
      }
    }


    getMonthlySales=async()=>{
        const server_response=await ajax.totalMonthlyGrossProfit();
        if(server_response.status==="OK")
        {
          this.setState({
            monthly:server_response.details.amount_c
          })
        }
      }





  render(){
      return (
        <DashCard 
            title="Daily Gross Profit"
            value={this.state.daily}
            caption={"This month: UGX. " + this.state.monthly}
            icon={"fas fa-chart-line text-secondary"}
            progressbar="bg-primary"
            />

      );
    
 
  }
}

export default SaleGrossProfitCard;